module.exports = __webpack_public_path__ + "static/img/J_clovers.d05a140.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/J_clovers.svg
// module id = tjrr
// module chunks = 1